import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";

export const getProject = gql`{
    currentProject{
        config
        extension
        pid
        collectiontype
    }
}`

export const getMyPins = gql`
    query getCurrentUserPins ($projectId: Int!) {
        getCurrentUserPins(pid: $projectId) {
            pin
            conversational {
              edges {
                node {
                  currentRecordingLength
                  maxRecordingLength
                }
              }
            }
        }
    }
`

export const getSpecificProject = gql`
    query project ($projectId: Int) {
        project(pid: $projectId) {
            config
            extension
            collectiontype
        }
    }
`

export const callCheckSub = gql`
  subscription callCheckSub($pin: Int, $pid: Int){
    callCheckSub(pid: $pid, pin: $pin){
      jsonObject
    }
  }
`;

export const checkPin = gql`
    mutation checkPin ($pin: Int!, $uid: Int!, $pid: Int!) {
        checkPin(pin: $pin, uid: $uid, pid: $pid) {
            pinlog {
              demographicInline
              demographicOutline
            }
            speakerInline {
              speakerId
              phonenumber
            }
            speakerOutline {
              speakerId
              phonenumber
            }
        }
    }
`

export const checkAsteriskChannel = gql`
    mutation checkAsteriskChannel ($phonenumber: String!, $pin: Int!, $pid: Int!) {
        checkAsteriskChannel(phonenumber: $phonenumber, pin: $pin, pid: $pid) {
            done
        }
    }
`

export const createSpeaker = gql`
    mutation createSpeaker($pid: Int!, $phonenumber: String!, $countryCode: Int) {
        createSpeaker(pid: $pid, phonenumber: $phonenumber, countryCode: $countryCode) {
            jsonObject                    
        }                            
    }
`

export const createDevices = gql`
    mutation createDevices ($pid: Int!, 
                            $phonenumberInline: String!, 
                            $countryCodeInline: Int, 
                            $countryCodeOutline: Int, 
                            $phonenumberOutline: String!,
                            $ageInline: Int,
                            $genderInline: Int,
                            $regionInline: Int,
                            $ageOutline: Int,
                            $genderOutline: Int,
                            $regionOutline: Int) {
        createDevices(pid: $pid, phonenumberInline: $phonenumberInline, phonenumberOutline: $phonenumberOutline, 
                    countryCodeInline: $countryCodeInline, countryCodeOutline: $countryCodeOutline, 
                    ageInline: $ageInline, genderInline: $genderInline, regionInline: $regionInline, 
                    ageOutline: $ageOutline, genderOutline: $genderOutline, regionOutline: $regionOutline) {
            jsonObject
        }
    }
`

export const createSpeakers = gql`
    mutation createSpeakers ($pid: Int!, 
                            $phonenumberInline: String!, 
                            $countryCodeInline: Int, 
                            $countryCodeOutline: Int, 
                            $phonenumberOutline: String!) {
        createSpeakers(pid: $pid, phonenumberInline: $phonenumberInline, phonenumberOutline: $phonenumberOutline, 
                    countryCodeInline: $countryCodeInline, countryCodeOutline: $countryCodeOutline) {
            jsonObject
        }
    }
`

export const createLog = gql`
    mutation createLogs($destination: Int!, 
                        $channel: String!, 
                        $src: Int!, 
                        $spk1: String!, 
                        $spk2: String!, 
                        $demo1: String!, 
                        $demo2: String!, 
                        $pin: Int!, 
                        $pid: Int!,
                        $receiverSpeakerid: Int!, 
                        $callerSpeakerid: Int!, 
                        $callerCarrier: String!, 
                        $receiverCarrier: String!,
                        $receiverDeviceid: Int!, 
                        $callerDeviceid: Int! ){
        createLogs(destination:$destination, 
                    channel:$channel, src:$src, 
                    spk1: $spk1, spk2: $spk2, demo1: $demo1, demo2: $demo2, 
                    pin: $pin, pid: $pid,
                    receiverSpeakerid: $receiverSpeakerid, callerSpeakerid: $callerSpeakerid, 
                    callerCarrier: $callerCarrier, receiverCarrier: $receiverCarrier,
                    receiverDeviceid: $receiverDeviceid, callerDeviceid: $callerDeviceid){
            calls{
                cid
            }
        }
    }`

export const createCallReport = gql`
    mutation createCallReport($uid: Int!,
                            $pid: Int!,
                            $pin: Int!,
                            $data: JSONString!,
                            $description: String,
                            $status: String!) {
            createCallReport(uid: $uid, pid: $pid, pin: $pin,
                            data: $data, description: $description, status: $status) {
                callReport {
                    crId
                }
            }
        }
`

export const canReport = gql`
    mutation canReportCall($uid: Int!, $pin: Int!, $pid: Int!) {
        canReportCall(uid: $uid, pin: $pin, pid: $pid) {
            canReport
        }
    }
`

export const removePinQueue = gql`
    mutation removePinQueue($pid: Int!, $pin: Int!) {
        removePinQueue(pid: $pid, pin: $pin) {
            done
        }
    }
`

export const queueCallSub = gql`
  subscription queueCallSub($pin: Int, $pid: Int){
    queueCallSub(pid: $pid, pin: $pin){
      jsonObject
    }
  }
`;

export const managePin = gql`
    mutation managePin($pin: Int!, $uid: Int!, $pid: Int!){
        managePin(pin: $pin, uid: $uid, pid: $pid) {
            jsonObject
        }
    }
`

export const currentUser = gql`
    query{
      currentUser {
        uid
      }
    }
`

export const withDataAndErrors = compose(
    graphql(getProject, {
        options: {
            errorPolicy: "all"
        },
        name: "GetConfig"
    }), 
    graphql(createLog, {
        name: "CreateLog"
    }),
    graphql(checkPin, {
        name: "CheckPin"
    }),
    graphql(getSpecificProject, {
        // options: (props) => ({
        //     variables: {
        //         projectId: props.match.params.id
        //     },
        //     errorPolicy: "all",
        //     fetchPolicy: 'cache-and-network'
        // }),
        name: "GetSpecificProject"
    }),
    graphql(managePin, {
        options: {
            errorPolicy: 'all'
        },
        name: "ManagePin"
    }),
    graphql(currentUser, {
        name: 'CurrentUser'
    })
);

export const checkAsteriskChannelCompose = compose(
    graphql(checkAsteriskChannel, {
        name: 'CheckAsteriskChannel'
    }),
);



// WEBPACK FOOTER //
// ./src/views/callform/graph.js